import React, { Component } from "react";
import { Player } from 'video-react';

export default class Audio extends Component {
	
	render () {
		
		let audio 	= this.props.audio;
		let poster 	= this.props.poster;
						    
	    return (
		    					
			<div className="scope-video">
				<Player
					playsInline
					poster={poster}
					src={audio}
				/>
			</div>
		    
		)
			
	}
}
